import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const SafetyPolicy = lazy(() => import("@/pages/policies/SafetyPolicy"));

export const Route = createFileRoute("/_public/safety")({
  component: SafetyPolicy,
});
